var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.418 3.20312C10.015 3.20312 3.20312 10.015 3.20312 18.418C3.20312 26.8209 10.015 33.6328 18.418 33.6328C26.8209 33.6328 33.6328 26.8209 33.6328 18.418C33.6328 10.015 26.8209 3.20312 18.418 3.20312ZM0 18.418C0 8.24601 8.24601 0 18.418 0C28.5899 0 36.8359 8.24601 36.8359 18.418C36.8359 28.5899 28.5899 36.8359 18.418 36.8359C8.24601 36.8359 0 28.5899 0 18.418Z",
    fill: "#53D0A4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4633 11.167L28.7282 13.4319L15.3598 26.8004L8.10938 19.5499L10.3743 17.285L15.3598 22.2705L26.4633 11.167Z",
    fill: "#53D0A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/InviteIcon.27153f5460dc618b159eb3d953340eeb.svg";
export { ForwardRef as ReactComponent };